/* eslint-disable */
/* This file was auto-generated using ./bin/mkI18n.ts */
export const en = {
    "$1 - Round 2": "$1 - Round 2",
    "$1 ascending": "$1 ascending",
    "$1 descending": "$1 descending",
    "$1 devis": "$1 devis",
    "$1 has cancelled this offer request. Thank you very much for your efforts":
        "$1 has cancelled this offer request. Thank you very much for your efforts",
    "$1 has gone to the negotiations phase, where he has the possibility to update the positions and deductions again.":
        "$1 has gone to the negotiations phase, where he has the possibility to update the positions and deductions again.",
    '$1 has sent you the final contract proposal. Click on "Check contract proposal" to accept the contract.':
        '$1 has sent you the final contract proposal. Click on "Check contract proposal" to accept the contract.',
    "$1 in this devis": "$1 in this devis",
    "$1 in this project": "$1 in this project",
    '$1 invites you to submit an offer for the second round. Click on "Submit 2nd Round Offer" to enter your conditions.':
        '$1 invites you to submit an offer for the second round. Click on "Submit 2nd Round Offer" to enter your conditions.',
    "$1 would like to ask you for an offer.": "$1 would like to ask you for an offer.",
    ".01s and .crbx": ".01s and .crbx",
    Abbreviation: "Abbreviation",
    Accept: "Accept",
    "Accept offer": "Accept offer",
    "Access denied": "Access denied",
    "Acknowledged!": "Acknowledged!",
    Active: "Active",
    Activity: "Activity",
    Add: "Add",
    "Add $1": "Add $1",
    "Add contact": "Add contact",
    "Add contractor": "Add contractor",
    "Add contacts if you wish to select submitters": "Add contacts if you wish to select submitters",
    "Add deduction": "Add deduction",
    "Add devis template": "New Template",
    "Add new project": "Add new project",
    "Add Smart Devis template": "Add Smart Devis template",
    "Add sub-total": "Add sub-total",
    "Add to submitters": "Add to submitters",
    Added: "Added",
    "Additional fileds": "Additional fileds",
    "Additional information": "Additional information",
    Address: "Address",
    "Adjusted prices sent to $1": "Adjusted prices sent to $1",
    "Admin Dashboard": "Admin Dashboard",
    "Admin Panel": "Admin Panel",
    All: "All",
    "All Projects": "All Projects",
    "All changelogs (change app language in order to view other languages):":
        "All changelogs (change app language in order to view other languages):",
    "All data in fields will be lost.": "All data in fields will be lost.",
    "All devis created, inserted or uploaded to the project will be listed here":
        "All devis created, inserted or uploaded to the project will be listed here",
    "All devis data will be lost.": "All devis data will be lost.",
    "All devis preview": "All devis preview",
    "All offers": "All offers",
    "All offers rejected": "All offers rejected",
    "All project details, estimates, devis and positions will be copied to new project.":
        "All project details, estimates, devis and positions will be copied to new project.",
    "All project details, estimates, devis and positions will be copied to template.":
        "All project details, estimates, devis and positions will be copied to template.",
    "All projects": "All projects",
    "All the Contractors from our Partner Network can be seen here!":
        "All the Contractors from our Partner Network can be seen here!",
    Amount: "Amount",
    Angebot: "Angebot",
    "Approval requested": "Approval requested",
    Architect: "Architect",
    "Architect details:": "Architect details:",
    "Architect initial round devis": "Architect initial round devis",
    "Architect negotiations round devis": "Architect negotiations round devis",
    Archived: "Archived",
    "Are you sure you want to create copy of that project?": "Are you sure you want to create copy of that project?",
    "Are you sure you want to create template?": "Are you sure you want to create template?",
    "Are you sure you want to delete devis?": "Are you sure you want to delete devis?",
    "Are you sure you want to delete project?": "Are you sure you want to delete project?",
    "Are you sure you want to delete template?": "Are you sure you want to delete template?",
    "Are you sure you want to delete this contact?": "Are you sure you want to delete this contact?",
    "Are you sure you want to delete this contractor?": "Are you sure you want to delete this contractor?",
    "Are you sure you want to delete this partner?": "Are you sure you want to delete this partner?",
    "Are you sure you want to delete this Smart Devis Template?":
        "Are you sure you want to delete this Smart Devis Template?",
    "Are you sure you want to delete this template?": "Are you sure you want to delete this template?",
    "Are you sure you want to import all valid contacts available below?":
        "Are you sure you want to import all valid contacts available below?",
    "Are you sure you want to proceed?": "Are you sure you want to proceed?",
    "Are you sure you want to reject offer?": "Are you sure you want to reject offer?",
    "Are you sure you want to remove that form?": "Are you sure you want to remove that form?",
    "At Smart Devis, we believe in protecting your privacy. As we continue to improve our product and features, we've also revised our":
        "At Smart Devis, we believe in protecting your privacy. As we continue to improve our product and features, we've also revised our",
    "At unit prices": "At unit prices",
    "Attach.": "Attach.",
    "Attach.{attachments on positions view}": "Attach.{attachments on positions view}",
    "Attachment, e.g protocol or final document:": "Attachment, e.g protocol or final document:",
    Attachments: "Attachments",
    "Attachments Upload": "Attachments Upload",
    "Authentication failed, please try again": "Authentication failed, please try again",
    Back: "Back",
    Bauabzug: "Bauabzug",
    Bauabzüge: "Bauabzüge",
    "Before the contract is created, the contractor must approve the price adjustments you made.":
        "Before the contract is created, the contractor must approve the price adjustments you made.",
    "Billing address": "Billing address",
    CHF: "CHF",
    Cancel: "Cancel",
    "Cancelled by architect": "Cancelled by architect",
    "Cannot be empty": "Cannot be empty",
    "Cannot create round from non submitted offer": "Cannot create round from non submitted offer",
    Cantons: "Cantons",
    Categories: "Categories",
    "Change logo": "Change logo",
    Changelog: "Changelog",
    "Changelog editor": "Changelog editor",
    "Check contract proposal": "Check contract proposal",
    "Choose client's representative contact information source":
        "Choose client's representative contact information source",
    "Choose project for the duplicated devis": "Choose project for the duplicated devis",
    City: "City",
    "Clear all values": "Clear all values",
    Client: "Client",
    "Client’s representative": "Client’s representative",
    Close: "Close",
    Comment: "Comment",
    "Comment to the offer created by $1": "Comment to the offer created by $1",
    Comments: "Comments",
    "Company Details": "Company Details",
    "Company Details are missing. Please fill profile info": "Company Details are missing. Please fill profile info",
    "Company Name": "Company Name",
    "Company Name 2": "Company Name 2",
    "Company name": "Company name",
    "Company name line 2": "Company name line 2",
    Comparison: "Comparison",
    "Complete the creation of your account": "Complete the creation of your account",
    "Complete your data to be able to use Smart Devis without restrictions.":
        "Complete your data to be able to use Smart Devis without restrictions.",
    Conditions: "Conditions",
    "Conditions, positions and deductions can be:": "Conditions, positions and deductions can be:",
    Confirm: "Confirm",
    "Confirm contacts import": "Confirm contacts import",
    "Congratulations! The submission is closed. $1 will contact you directly.":
        "Congratulations! The submission is closed. $1 will contact you directly.",
    "Connecting an offer": "Connecting an offer",
    "Construction management": "Construction management",
    "Construction object": "Construction object",
    Contact: "Contact",
    "Contact details": "Contact details",
    "Contact Info": "Contact Info",
    Contacts: "Contacts",
    Content: "Content",
    Contract: "Contract",
    "Contract created": "Contract created",
    "Contract created $1": "Contract created $1",
    "Contract prepared, you can view it in the finalization step":
        "Contract prepared, you can view it in the finalization step",
    "Contract preview": "Contract preview",
    "Contract preview:": "Contract preview:",
    Contractor: "Contractor",
    "Contractor attachments": "Contractor attachments",
    "Contractor attachments to the offer created by $1": "Contractor attachments to the offer created by $1",
    "Contractor fills": "Contractor fills",
    "Contractor name": "Contractor name",
    "Contractor offer proposals": "Contractor offer proposals",
    "Contractor recommendation": "Contractor recommendation",
    "Contractors directory": "Contractors directory",
    "Contractors Directory": "Contractors Directory",
    "Contractors Directory is empty!": "Contractors Directory is empty!",
    "Contractors Directory is unreachable": "Contractors Directory is unreachable/offline!",
    "Contractors invited": "Contractors invited",
    "Convert to PER position": "Convert to PER position",
    "Convert to basic position": "Convert to basic position",
    "Copied!": "Copied!",
    Copies: "Copies",
    "Copy $1": "Copy $1",
    "Copy details": "Copy details",
    "Copy from client": "Copy from client",
    "Copy to current": "Copy to current",
    "Cost estimate (original)": "Cost estimate (original)",
    "Cost estimate (revised)": "Cost estimate (revised)",
    "Cost estimate VAT": "Cost estimate VAT",
    "Could not detect any valid contacts.": "Could not detect any valid contacts.",
    Country: "Country",
    Create: "Create",
    "Create Tender": "Create Tender",
    "Create a new devis from free text positions. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.":
        "Create a new devis from free text positions. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.",
    "Create a new devis from one of your templates. The devis in the project and the template can be edited independently of each other. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.":
        "Create a new devis from one of your templates. The devis in the project and the template can be edited independently of each other. The contractor fills out the offer directly in the application. Thanks to the standardized format, you can compare the offers point by point.",
    "Create from custom template": "Create from custom template",
    "Create from template": "Create from template",
    "Create new": "Create new",
    "Create partner": "Create partner",
    "Create project": "Create project",
    "Create project {submit button}": "Create project {submit button}",
    "Create template": "Create template",
    "Create template {submit button}": "Create template {submit button}",
    Created: "Created",
    "Creation date": "Creation date",
    "Current round attachments": "Current round attachments",
    DE: "DE",
    Dashboard: "Dashboard",
    Deduction: "Deduction",
    Deductions: "Deductions",
    Delete: "Delete",
    "Desciption/subtitle": "Desciption/subtitle",
    Description: "Description",
    "Details / Compare (Max 3)": "Details / Compare (Max 3)",
    "Detected duplicate contacts.": "Detected duplicate contacts.",
    "Devis Templates": "Devis Templates",
    "Devis number": "Devis number",
    "Devis overview": "Devis overview",
    "Devis template": "Devis template",
    "Digit character present": "Digit character present",
    Discount: "Discount",
    Discounts: "Discounts",
    "Documents upload": "Documents upload",
    Download: "Download",
    "Download contacts template": "Download contacts template",
    "Download contract": "Download contract",
    "Draft, not to be used": "Draft, not to be used",
    "Drop your contacts file here": "Drop your contacts file here",
    "Drop your devis file here": "Drop your devis file here",
    "Drop your files here or select multiple documents": "Drop your files here or select multiple documents",
    Duplicate: "Duplicate",
    "Duplicate devis": "Duplicate devis",
    Duplicated: "Duplicated",
    EN: "EN",
    "Early payment discount": "Early payment discount",
    "Early payment discounts": "Early payment discounts",
    Edit: "Edit",
    "Edit account": "Edit account",
    "Edit contractor": "Edit contractor",
    "Edit project": "Edit project",
    Edited: "Edited",
    Email: "Email",
    "Email address": "Email address",
    "Empty List": "Empty List",
    "Enter $1": "Enter $1",
    "Enter $1. Press Shift + Enter for newline": "Enter $1. Press Shift + Enter for newline",
    "Enter unit": "Enter unit",
    "Entry date": "Entry date",
    "Entry date:": "Entry date:",
    Error: "Error",
    Errors: "Errors",
    "Excl. VAT": "Excl. VAT",
    "Exclude VAT": "Exclude VAT",
    Export: "Export",
    "Export comparison": "Export comparison",
    "Export offer": "Export offer",
    "Export preview": "Export preview",
    "Export project submitters": "Export project submitters",
    "Export recommendation": "Export recommendation",
    "Export to PDF": "Export to PDF",
    File: "File",
    "File based devis require price to be provided manually": "File based devis require price to be provided manually",
    "File name": "File name",
    "File size is too big": "File size is too big",
    "Filled by": "Filled by",
    "Filled out by": "Filled out by",
    Filler: "Filler",
    "Final attachments": "Final attachments",
    "Final prices are in review $1": "Final prices are in review $1",
    "Final round created": "Final round created",
    Finalization: "Finalization",
    "First name": "First name",
    "First round comment": "First round comment",
    "First round offer attachments": "First round offer attachments",
    "First round offer proposal": "First round offer proposal",
    "Flat rate": "Flat rate",
    "Flat-rate or at unit prices?": "Flat-rate or at unit prices?",
    "For a total price (Net + tax) of:": "For a total price (Net + tax) of:",
    "Forbidden extensions": "Forbidden extensions",
    "Free Text": "Free Text",
    General: "General",
    "General attachments": "General attachments",
    "General information": "General information",
    "General offer comments": "General offer comments",
    "Generate activity": "Generate activity",
    "Go back to offers": "Go back to offers",
    "Got it": "Got it",
    Gross: "Gross",
    "Gross price": "Gross price",
    Groups: "Groups",
    "I confirm that I want to cancel an offer request": "I confirm that I want to cancel an offer request",
    "I confirm that I want to invite these contractors": "I confirm that I want to invite these contractors",
    "I confirm that I want to send revised offer": "I confirm that I want to send revised offer",
    "I confirm that I want to send this to contractor for approval":
        "I confirm that I want to send this to contractor for approval",
    "I confirm, I want architect the change the offer": "I confirm, I want architect the change the offer",
    "I confirm, I want to accept architect's offer": "I confirm, I want to accept architect's offer",
    "I confirm, I want to submit my offer": "I confirm, I want to submit my offer",
    "I confirm, I want to submit my second round offer": "I confirm, I want to submit my second round offer",
    "I understand": "I understand",
    "I want to reject all other offers automatically when the contractor accepts the contract.":
        "I want to reject all other offers automatically when the contractor accepts the contract.",
    ID: "ID",
    "Identity admin console": "Identity admin console",
    "If you cancel this offer, you will not be able to invite this contractor again. Instead, you can start the second round in order to request a better offer.":
        "If you cancel this offer, you will not be able to invite this contractor again. Instead, you can start the second round in order to request a better offer.",
    "If you don't want to copy values (prices / amount) you can check clear value":
        "If you don't want to copy values (prices / amount) you can check clear value",
    "If you send the revised offer, conditions, positions and deductions will once again become readonly.":
        "If you send the revised offer, conditions, positions and deductions will once again become readonly.",
    Impersonation: "Impersonation",
    "Import contacts": "Import contacts",
    "Import devis": "Import devis",
    Initials: "Initials",
    "In negotiation": "In negotiation",
    "In negotiation from $1": "In negotiation from $1",
    "In second round": "In second round",
    "In the meanwhile, you can try refreshing the page": "In the meanwhile, you can try refreshing the page",
    "In this round you can upload an updated devis file": "In this round you can upload an updated devis file",
    "Incl. VAT": "Incl. VAT",
    "Include VAT": "Include VAT",
    "Initial round offer": "Initial round offer",
    "Invalid data will be ignored: ": "Invalid data will be ignored: ",
    "Invalid decimal number": "Invalid decimal number",
    "Invalid document": "Invalid document",
    "Invalid encryption key type": "Invalid encryption key type",
    "Invalid hex color": "Invalid hex color",
    "Invalid object": "Invalid object",
    Invite: "Invite",
    "Invite for Second Round": "Invite for Second Round",
    "Invite selected": "Invite selected",
    "Invited contractors will recieve an email, with the link to the devis, project specification, and an optional message.":
        "Invited contractors will recieve an email, with the link to the devis, project specification, and an optional message.",
    "Item not found": "Item not found",
    LE: "LE",
    "Last name": "Last name",
    "Later you can upload the file and have the contacts available in Smart Devis.":
        "Later you can upload the file and have the contacts available in Smart Devis.",
    "Latest action": "Latest action",
    "Latest action:": "Latest action:",
    "Leave comment in the document (optional):": "Leave comment in the document (optional):",
    Logout: "Logout",
    "Make your Devis available to the contractor in CRBx or .01s format. The contractor downloads this, fills it out and uploads the offer again in CRBx or .01s format. The contractor enters the total price and the discounts to enable you to compare the contractors on the platform.":
        "Make your Devis available to the contractor in CRBx or .01s format. The contractor downloads this, fills it out and uploads the offer again in CRBx or .01s format. The contractor enters the total price and the discounts to enable you to compare the contractors on the platform.",
    "Make your Devis available to the contractor in your own format. The contractor downloads this, creates his offer and uploads the offer. The contractor enters the total price and the discounts in Smart Devis to enable you to compare the contractors on the platform.":
        "Make your Devis available to the contractor in your own format. The contractor downloads this, creates his offer and uploads the offer. The contractor enters the total price and the discounts in Smart Devis to enable you to compare the contractors on the platform.",
    "Manage additional attachments": "Manage additional attachments",
    "Manage credentials": "Manage credentials",
    "Manage partners": "Manage partners",
    "Manage products": "Manage products",
    "Manage submitters": "Manage submitters",
    "Message to contractors (optional):": "Message to contractors (optional):",
    Mt: "Mt",
    Name: "Name",
    "Negotations round attachments": "Negotations round attachments",
    "Negotations round comment": "Negotations round comment",
    "Negotiate (Max 3)": "Negotiate (Max 3)",
    Negotiation: "Negotiation",
    "Negotiation Unit Price": "Negotiation Unit Price",
    "Negotiation Value": "Negotiation Value",
    "Negotiation from $1": "Negotiation from $1",
    "Negotiation is the last moment for changes.\nIn the negotitation, you can:\n- adjust prices provided by the contractor\n- export final offers to the pdf to share it with the client\n":
        "Negotiation is the last moment for changes.\nIn the negotitation, you can:\n- adjust prices provided by the contractor\n- export final offers to the pdf to share it with the client\n",
    Negotiations: "Negotiations",
    "Negotiations round offer": "Negotiations round offer",
    "Negotiations round offer proposal": "Negotiations round offer proposal",
    Net: "Net",
    "Net + VAT": "Net + VAT",
    "Net incl. tax": "Net incl. tax",
    "Net price": "Net price",
    "New Devis Template Name": "New Devis Template Name",
    "New Smart Devis Template Name": "New Smart Devis Template Name",
    "New Freetext devis": "New Freetext devis",
    "New PER position": "New PER position",
    "New Project Name": "New Project Name",
    "New Template Name": "New Template Name",
    "New additional information": "New additional information",
    "New app version is available, please reload:": "New app version is available, please reload:",
    "New contact": "New contact",
    "New free text condition": "New free text condition",
    "New free text position": "New free text position",
    "New section title": "New section title",
    "New subsection": "New subsection",
    "New tender": "New tender",
    Next: "Next",
    "Next round created": "Next round created",
    "Next round requested": "Next round requested",
    "Next round requested $1": "Next round requested $1",
    "No contractor user": "No contractor user",
    "No data": "No data",
    "No devis added yet": "No devis added yet",
    "No digit character present": "No digit character present",
    "No lowercase character present": "No lowercase character present",
    "No matching templates found": "No matching templates found",
    "No offer": "No offer",
    "No offers available": "No offers available",
    "No request is yet in the contract phase": "No request is yet in the contract phase",
    "No uppercase character present": "No uppercase character present",
    "Not a number type": "Not a number type",
    "Not a string type": "Not a string type",
    "Not a valid email": "Not a valid email",
    "Not an array type": "Not an array type",
    "Not an boolean type": "Not an boolean type",
    "Not an object type": "Not an object type",
    "Not fetched": "Not fetched",
    "Not found": "Not found",
    "Not specified": "Not specified",
    "Not yet invited": "Not yet invited",
    Number: "Number",
    "Offer Request is not ready to submit": "Offer Request is not ready to submit",
    "Offer Requests": "Offer Requests",
    "Offer cancelled": "Offer cancelled",
    "Offer comparison": "Offer comparison",
    "Offer connected": "Offer connected",
    "Offer from $1": "Offer from $1",
    "Offer has already been assigned to another account": "Offer has already been assigned to another account",
    "Offer is being created $1": "Offer is being created $1",
    "Offer received $1": "Offer received $1",
    "Offer requested": "Offer requested",
    "Offer submitted": "Offer submitted",
    Offers: "Offers",
    "Offers cancelled": "Offers cancelled",
    "Offers comparison": "Offers comparison",
    "Offers tab will be accessible after picking at least one submitter and providing positions and deductions":
        "Offers tab will be accessible after picking at least one submitter and providing positions and deductions",
    "Offers:": "Offers:",
    "Once contractors are invited, parts of the system like possitions, deductions, and conditions will become readonly.":
        "Once contractors are invited, parts of the system like possitions, deductions, and conditions will become readonly.",
    "Once the second round has been initiated only selected contractors can submit offers,":
        "Once the second round has been initiated only selected contractors can submit offers,",
    Open: "Open",
    "Open Devis": "Open Devis",
    "Open offer": "Open offer",
    "Original devis": "Original devis",
    Other: "Other",
    "Other formats": "Other formats",
    Owner: "Owner",
    "Owner’s representative": "Owner’s representative",
    "PER position": "PER position",
    "Page $1": "Page $1",
    Partners: "Partners",
    Pauschalabzug: "Pauschalabzug",
    Pauschalabzüge: "Pauschalabzüge",
    "Phone Number": "Phone Number",
    "Phone number": "Phone number",
    "Planned start: $1": "Planned start: $1",
    "Planner / Architect": "Planner / Architect",
    "Planner/Architect": "Planner/Architect",
    "Please add your work categories": "Please add your work categories",
    "Please check that you've put correct data": "Please check that you've put correct data",
    "Please check your uploaded file and try again.": "Please check your uploaded file and try again.",
    "Please enter a Street": "Please enter a Street",
    "Please enter a Name": "Please enter a Name",
    "Please make sure your business details are filled out before send the offer request":
        "Please make sure your business details are filled out before send the offer request",
    "Please provide the price in input below.": "Please provide the price in input below.",
    "Please review the documents, and": "Please review the documents, and",
    "Please select canton": "Please select canton",
    Position: "Position",
    Positions: "Positions",
    "Positions and deductions can be:": "Positions and deductions can be:",
    "Postal Code": "Postal Code",
    "Postal code": "Postal code",
    Prefix: "Prefix",
    Price: "Price",
    "Printed on $1{date}": "Printed on $1{date}",
    "Privacy Policy": "Privacy Policy",
    Proceed: "Proceed",
    "Product groups": "Product groups",
    Products: "Products",
    Project: "Project",
    "Project Name": "Project Name",
    "Project Number": "Project Number",
    "Project Type": "Project Type",
    "Project address": "Project address",
    "Project details": "Project details",
    "Project details:": "Project details:",
    Projects: "Projects",
    "Provide gross price": "Provide gross price",
    Quantity: "Quantity",
    "Re-submit": "Re-submit",
    "Re-upload file": "Re-upload file",
    "Recent tenders activity": "Recent tenders activity",
    "Recommended contractor": "Recommended contractor",
    "Refresh the page": "Refresh the page",
    Reject: "Reject",
    "Reject changes": "Reject changes",
    "Reject changes and allow architect to adjust the offer one more time":
        "Reject changes and allow architect to adjust the offer one more time",
    Rejected: "Rejected",
    Reload: "Reload",
    "Reminders sent": "Reminders sent",
    Remove: "Remove",
    "Remove contact": "Remove contact",
    "Remove contractor": "Remove contractor",
    "Remove from submitters": "Remove from submitters",
    "Remove partner": "Remove partner",
    "Remove Smart Devis Template": "Remove Smart Devis Template",
    "Remove template": "Remove template",
    Removed: "Removed",
    "Removing this section will also remove all the positions inside.":
        "Removing this section will also remove all the positions inside.",
    Rename: "Rename",
    Reports: "Reports",
    "Request cancelled $1": "Request cancelled $1",
    "Request rejected $1": "Request rejected $1",
    "Requested $1": "Requested $1",
    "Round 1 Unit Price": "Round 1 Unit Price",
    "Round 1 Value": "Round 1 Value",
    "Round 2": "Round 2",
    "Round 2 Unit Price": "Round 2 Unit Price",
    "Round 2 Value": "Round 2 Value",
    "Row $1 - Column $2": "Row $1 - Column $2",
    "SECTION $1": "SECTION $1",
    "STEP $1": "STEP $1",
    Save: "Save",
    "Save and close": "Save and close",
    "Save as template": "Save as template",
    "Save changes": "Save changes",
    "Save comments and close": "Save comments and close",
    Saved: "Saved",
    Saving: "Saving",
    "Search...": "Search...",
    "Second offer received $1": "Second offer received $1",
    "Second round": "Second round",
    "Section name": "Section name",
    Select: "Select",
    "Select contractor you want to highlight in the document as a preferable to work with:":
        "Select contractor you want to highlight in the document as a preferable to work with:",
    "Select date": "Select date",
    "Select file": "Select file",
    "Select files": "Select files",
    "Selected Submitters": "Selected Submitters",
    "Selected contractors will recieve an email, with the link to the devis, project specification, and an optional message.":
        "Selected contractors will recieve an email, with the link to the devis, project specification, and an optional message.",
    "Selected for this project": "Selected for this project",
    Send: "Send",
    "Send for approval": "Send for approval",
    "Send message": "Send message",
    "Send reminder": "Send reminder",
    "Send request for approval": "Send request for approval",
    "Should be empty": "Should be empty",
    "Show 2nd round offer": "Show 2nd round offer",
    "Show Devis": "Show Devis",
    "Show conditions": "Show conditions",
    "Show details": "Show details",
    "Show offer": "Show offer",
    "Show tender": "Show tender",
    Sign: "Sign",
    "Since you submitted a file-based devis, we’re not able to read the price directly from the document.":
        "Since you submitted a file-based devis, we’re not able to read the price directly from the document.",
    "Small screen support is coming soon.": "Small screen support is coming soon.",
    "Smart Devis": "Smart Devis",
    "Smart Devis Templates": "Smart Devis Templates",
    "Smart Devis template": "Smart Devis template",
    "Some contacts cannot be imported due to the email duplication.":
        "Some contacts cannot be imported due to the email duplication.",
    "Some fields have not been filled. Please fill them and try again":
        "Some fields have not been filled. Please fill them and try again",
    "Some sections contain no positions; they'll be omitted.":
        "Some sections contain no positions; they'll be omitted.",
    "Something went wrong uploading the picture. Try again": "Something went wrong uploading the picture. Try again",
    "Something went wrong, try again later": "Something went wrong, try again later",
    "Sorry, we're working on it.": "Sorry, we're working on it.",
    "Sort by": "Sort by",
    "Special provisions": "Special provisions",
    "Specialist planner": "Specialist planner",
    "Specialist planner #2": "Specialist planner #2",
    "Specialist planner #3": "Specialist planner #3",
    "Specialist planner #4": "Specialist planner #4",
    "Specialist planner #5": "Specialist planner #5",
    Specification: "Specification",
    St: "St",
    "Start Second Round": "Start Second Round",
    "Start negotiation": "Start negotiation",
    "Start second round": "Start second round",
    Status: "Status",
    Street: "Street",
    "Street Number": "Number",
    "Sub-total $1": "Sub-total $1",
    Submit: "Submit",
    "Submit 2nd round offer": "Submit 2nd round offer",
    "Submit a gross price": "Submit a gross price",
    Submitters: "Submitters",
    "Submitters list": "Submitters list",
    "Submitters updated": "Submitters updated",
    "Submitting offer will be no longer available after rejection.":
        "Submitting offer will be no longer available after rejection.",
    "Subsection $1": "Subsection $1",
    Subtotal: "Subtotal",
    Sum: "Sum",
    "Sum\\n(CHF)": "Sum\\n(CHF)",
    "Supported files": "Supported files",
    Surname: "Surname",
    Tax: "Tax",
    Template: "Template",
    Templates: "Templates",
    "Terms of Service": "Terms of Service",
    Text: "Text",
    "Text paragraph": "Text paragraph",
    "Thanks to the support of ConReal Swiss AG and these partner companies, the use of Smart Devis is free of charge for you.":
        "Thanks to the support of ConReal Swiss AG and these partner companies, the use of Smart Devis is free of charge for you.",
    "The email address is already in use by another account.(auth/email-already-exists)":
        "The email address is already in use by another account.(auth/email-already-exists)",
    "There is no saved Smart Devis Templates": "There is no saved Smart Devis Templates",
    "There is no saved Work Description Templates": "There is no saved Work Description Templates",
    "The required fields are company name and email.": "The required fields are company name and email.",
    "The second round is a flexible way to adjust the offer.":
        "The second round is a flexible way to adjust the offer.",
    "There are no contacts matching your search": "There are no contacts matching your search",
    "This contact cannot be deleted, it's used in some project":
        "This contact cannot be deleted, it's used in some project",
    "This contractor is in some offers and cannot be deleted":
        "This contractor is in some offers and cannot be deleted",
    "This initiates finalization. Once prices are accepted by the contractor contract is generated.":
        "This initiates finalization. Once prices are accepted by the contractor contract is generated.",
    "This is a Smart Devis Template, it is read only!": "This is a Smart Devis Template, it is read only!",
    "This position can only be moved to a subsection": "This position can only be moved to a subsection",
    "This project exists for demonstrating how a project works.":
        "This project exists for demonstrating how a project works.",
    "This will remove the contractor from all your projects. Proceed?":
        "This will remove the contractor from all your projects. Proceed?",
    Title: "Title",
    "To change devis type, detach current devis first": "To change devis type, detach current devis first",
    "To change round values, open current devis": "To change round values, open current devis",
    "To contract": "To contract",
    "To import your existing contacts,": "To import your existing contacts,",
    "To submit an offer for:": "To submit an offer for:",
    "Total price": "Total price",
    Translations: "Translations",
    Type: "Type",
    "Type to add options": "Type to add options",
    Unit: "Unit",
    "Unit price": "Unit price",
    "Unit price\\n(CHF)": "Unit price\\n(CHF)",
    Unknown: "Unknown",
    Update: "Update",
    "Update Tender": "Update Tender",
    "Update to our Policy Privacy and Terms of Service": "Update to our Policy Privacy and Terms of Service",
    "Updated devis": "Updated devis",
    "Updated entry date:": "Updated entry date:",
    Upload: "Upload",
    "Upload devis": "Upload devis",
    "Upload file": "Upload file",
    "Upload filled contacts file": "Upload filled contacts file",
    "Upload logo": "Upload logo",
    "Uploaded devis": "Uploaded devis",
    "Uploaded file": "Uploaded file",
    Url: "Url",
    "Use existing": "Use existing",
    "Use existing devis": "Use existing devis",
    "Use selected": "Use selected",
    "User info": "User info",
    Value: "Value",
    "Value is too long": "Value is too long",
    "Value is too long (3)": "Value is too long (3)",
    "Value is too long (10)": "Value is too long (10)",
    "Value is too long (50)": "Value is too long (50)",
    "Value is too long (250)": "Value is too long (250)",
    "Value is too short": "Value is too short",
    "Value is too short (6)": "Value is too short (6)",
    "Value must be equal or greater than 0": "Value must be equal or greater than 0",
    "Value not allowed": "Value not allowed",
    "Values are not the same": "Values are not the same",
    "Version date": "Version date",
    "Version:": "Version:",
    "View projects": "View projects",
    "Wait for the client to make a finall call": "Wait for the client to make a finall call",
    "Waiting for contractor approval": "Waiting for contractor approval",
    Warning: "Warning",
    "Warning: all project data will be lost.": "Warning: all project data will be lost.",
    "WD Admin Templates": "WD Admin Templates",
    "We are under maintenance": "We are under maintenance",
    "We encountered a problem": "We encountered a problem",
    "We track our errors automatically, but if the problem persists,":
        "We track our errors automatically, but if the problem persists,",
    "We will be back in less than 1 hour. Sorry for the inconvenience.":
        "We will be back in less than 1 hour. Sorry for the inconvenience.",
    "What's new?": "What's new?",
    Wo: "Wo",
    Work: "Work",
    "Work Categories": "Work Categories",
    "Work Categories De (Work categories must be separated with a comma)":
        "Work Categories De (Work categories must be separated with a comma)",
    "Work Categories En (Work categories must be separated with a comma)":
        "Work Categories De (Work categories must be separated with a comma)",
    "Work category": "Work category",
    "Work end": "Work end",
    "Work start": "Work start",
    "Work with positions and deductions the architect wants you to update.":
        "Work with positions and deductions the architect wants you to update.",
    "Work with positions and deductions you want to be updated by the contractor.":
        "Work with positions and deductions you want to be updated by the contractor.",
    "You are about to cancel the request for offer from:": "You are about to cancel the request for offer from:",
    "You are about to create a demo project": "You are about to create a demo project",
    "You are about to create a devis template": "You are about to create a devis template",
    "You are about to create a Smart Devis Template": "You are about to create a Smart Devis Template",
    "You are about to invite selected contractors:": "You are about to invite selected contractors:",
    "You are about to rename a devis template": "You are about to rename a devis template",
    "You are about to rename a Smart Devis Template": "You are about to rename a Smart Devis Template",
    "You are about to send contract for approval to:": "You are about to send contract for approval to:",
    "You are about to send reminder to selected contractors:":
        "You are about to send reminder to selected contractors:",
    "You are about to send second round offer to:": "You are about to send second round offer to:",
    "You are not allowed to delete the devis after a contractor has been invited.":
        "You are not allowed to delete the devis after a contractor has been invited.",
    "You are not allowed to edit the devis after a contractor has been invited.":
        "You are not allowed to edit the devis after a contractor has been invited.",
    "You can edit your account here": "You can edit your account here",
    "You can only compare contractors with the same status": "You can only compare contractors with the same status",
    "You can start the negotiation round only with contractors with the same status":
        "You can start the negotiation round only with contractors with the same status",
    "You can start the second round only with contractors with the same status":
        "You can start the second round only with contractors with the same status",
    "You cannot be logged in as an architect": "You cannot be logged in as an architect",
    "You don't have sufficient permissions to view this page":
        "You don't have sufficient permissions to view this page",
    'You have accepted the invitation. Click on "Open Devis" to enter your conditions.':
        'You have accepted the invitation. Click on "Open Devis" to enter your conditions.',
    "You have declined the invitation to submit an offer.": "You have declined the invitation to submit an offer.",
    "You have pending offers. This view is now read only": "You have pending offers. This view is now read only",
    "You have submitted the offer. This view is now read only":
        "You have submitted the offer. This view is now read only",
    "You have unsaved items. If you leave, the data will be lost":
        "You have unsaved items. If you leave, the data will be lost",
    "You were not chosen to contract": "You were not chosen to contract",
    "You will not be able to edit the devis nor send the contract to other contractors.":
        "You will not be able to edit the devis nor send the contract to other contractors.",
    "You're about to accept an offer for:": "You're about to accept an offer for:",
    "You're about to create contract with": "You're about to create contract with",
    "You're about to submit an offer for:": "You're about to submit an offer for:",
    "You're about to submit second round offer for:": "You're about to submit second round offer for:",
    "Your are about to start a second round with selected contractors:":
        "Your are about to start a second round with selected contractors:",
    "Your are about to start final round with:": "Your are about to start final round with:",
    "Your contract with $1 is ready to download": "Your contract with $1 is ready to download",
    "Your offer for the second round has been successfully submitted.":
        "Your offer for the second round has been successfully submitted.",
    "Your offer has been successfully submitted.": "Your offer has been successfully submitted.",
    "Your offer was not chosen to the second round": "Your offer was not chosen to the second round",
    "Your offer will be placed here. Click 'Upload file' button to upload an offer.":
        "Your offer will be placed here. Click 'Upload file' button to upload an offer.",
    "Your user account hasn't been filled with all necessary data":
        "Your user account hasn't been filled with all necessary data",
    "Zip code": "Zip code",
    and: "and",
    applied: "applied",
    cancel: "cancel",
    city: "city",
    "contacts-template": "contacts-template",
    "contractors responded": "contractors responded",
    "contractors responded to second round": "contractors responded to second round",
    d: "d",
    description: "description",
    "download and fill out the contacts template (.csv format) available below.":
        "download and fill out the contacts template (.csv format) available below.",
    "e.g missing information": "e.g missing information",
    "email us": "email us",
    "feel free to contact our customer support.": "feel free to contact our customer support.",
    gl: "gl",
    h: "h",
    hl: "hl",
    "if you have any questions.": "if you have any questions.",
    in: "in",
    kJ: "kJ",
    kg: "kg",
    l: "l",
    m: "m",
    more: "more",
    "m²": "m²",
    "m³": "m³",
    negative: "negative",
    new: "new",
    number: "number",
    of: "of",
    percent: "percent",
    pl: "pl",
    positive: "positive",
    renovation: "renovation",
    restoration: "restoration",
    t: "t",
    "those not selected to the second round are being rejected from the offering.":
        "those not selected to the second round are being rejected from the offering.",
    "{Cancel adding/editing contractor}Cancel": "{Cancel adding/editing contractor}Cancel",
    "{Email subject}Accept changes": "{Email subject}Accept changes",
    "{Email subject}Contract created": "{Email subject}Contract created",
    "{Email subject}Contract proposal rejected": "{Email subject}Contract proposal rejected",
    "{Email subject}New registration": "{Email subject}New registration",
    "{Email subject}Offer accepted": "{Email subject}Offer accepted",
    "{Email subject}Offer from": "{Email subject}Offer from",
    "{Email subject}Offer rejected": "{Email subject}Offer rejected",
    "{Email subject}Offer reminder": "{Email subject}Offer reminder",
    "{Email subject}Offer request": "{Email subject}Offer request",
    "{Email subject}Request canceled": "{Email subject}Request canceled",
    "{Email subject}Second round offer request": "{Email subject}Second round offer request",
    "{Email subject}Smart Devis: Email address has changed": "{Email subject}Smart Devis: Email address has changed",
    "{Email subject}Smart Devis: Reset password": "{Email subject}Smart Devis: Reset password",
    "{Email subject}Smart Devis: Verify your e-mail address": "{Email subject}Smart Devis: Verify your e-mail address",
    "{Email subject}has rejected to provide an offer": "{Email subject}has rejected to provide an offer",
    "{Number}No": "{Number}No",
    "{TAG}ADDED": "{TAG}ADDED",
    "{TAG}EDITED": "{TAG}EDITED",
    "{TAG}REMOVED": "{TAG}REMOVED",
    "{a of company b}$1 of $2": "{a of company b}$1 of $2",
    "{alt}Before the contract is created, the contractor must approve the final version.":
        "{alt}Before the contract is created, the contractor must approve the final version.",
    "{contract doc}Contract amount": "{contract doc}Contract amount",
    "{offer submit} Once an offer is submitted you won’t be able to change the prices.":
        "{offer submit} Once an offer is submitted you won’t be able to change the prices.",
    "{page x} of $1": "{page x} of $1",
    "{second round submit} Once the offer is updated you won’t be able to change the prices.":
        "{second round submit} Once the offer is updated you won’t be able to change the prices."
}
